import { gql } from '@apollo/client';

export const FETCH_LMI_FORM = gql`
  fragment lmiContractData on ContractVersion {
    contractType
    displayName
    fileUrl
    id
    scrollRequired
    tag
    contractId
  }

  query Flex_FetchLmiForm($stateId: Int!, $tags: [ContractTag!]!) {
    lmiForm: currentContractVersion(stateId: $stateId, contractType: lmi, tag: $tags) {
      ...lmiContractData
    }
  }
`;
